import type { CombatProfile } from './api';

// Shared by the Insights tab and the player-hub card (Plan 053).

/** Efficiency is kills (M) per M of M-Sum — shown as thousand kills per M. */
export function formatEfficiency(efficiency: number | null | undefined): string {
  return efficiency == null ? '—' : `${(efficiency * 1000).toFixed(0)} K/M`;
}

// Neutral wording — neither profile is better than the other.
export const COMBAT_PROFILE_META: Record<
  Exclude<CombatProfile, null>,
  { label: string; hint: string; chip: string }
> = {
  fighting: {
    label: 'Mostly fighting',
    hint: 'Top quarter of kills per strength in the class',
    chip: 'border-rose-800 bg-rose-950/40 text-rose-200',
  },
  growing: {
    label: 'Mostly growing',
    hint: 'Few kills for the strength, but grew more than the class median',
    chip: 'border-sky-800 bg-sky-950/40 text-sky-200',
  },
};
